"use strict";

var _regeneratorRuntime = require("/node_modules/@babel/runtime/regenerator/index.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.API = void 0;

require("isomorphic-unfetch");

var _graphqlRequest = require("graphql-request");

var _urlcat = _interopRequireDefault(require("urlcat"));

var _types = require("./types");

var _constants = require("./constants");

var _responseBuilder = require("./utils/responseBuilder");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * Mintbase API.
 * Main entry point for users read Mintbase data.
 */


var API = /*#__PURE__*/function () {
  function API(apiConfig) {
    _classCallCheck(this, API);

    _defineProperty(this, "apiBaseUrl", _constants.API_BASE_NEAR_TESTNET);

    _defineProperty(this, "defaultLimit", 20);

    _defineProperty(this, "chainName", _types.Chain.near);

    _defineProperty(this, "networkName", void 0);

    _defineProperty(this, "constants", void 0);

    this.constants = apiConfig.constants;
    this.networkName = apiConfig.networkName || _types.Network.testnet;

    switch (apiConfig.chain) {
      case _types.Chain.near:
        if (this.networkName === _types.Network.testnet) {
          this.apiBaseUrl = this.constants.API_BASE_NEAR_TESTNET || apiConfig.apiBaseUrl || _constants.API_BASE_NEAR_TESTNET;
        } else if (this.networkName === _types.Network.mainnet) {
          this.apiBaseUrl = this.constants.API_BASE_NEAR_MAINNET || apiConfig.apiBaseUrl || _constants.API_BASE_NEAR_MAINNET;
        }

        this.chainName = _types.Chain.near;
        break;

      default:
        this.apiBaseUrl = this.constants.API_BASE_NEAR_TESTNET || apiConfig.apiBaseUrl || _constants.API_BASE_NEAR_TESTNET;
        this.chainName = apiConfig.chain || _types.Chain.near;
        break;
    }
  }
  /**
   * Fetch marketplace and each token's metadata (w/ cursor offset pagination enabled).
   * @param limit number of results
   * @param offset number of records to skip
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any


  _createClass(API, [{
    key: "fetchMarketplace",
    value: function () {
      var _fetchMarketplace = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(offset, limit) {
        var _this = this;

        var url, response, result, promises, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = (0, _urlcat["default"])("".concat(this.apiBaseUrl, "/api/rest/"), '/marketplace', {
                  limit: limit || this.defaultLimit,
                  offset: offset || 0
                });
                _context2.next = 3;
                return fetch(url);

              case 3:
                response = _context2.sent;
                _context2.next = 6;
                return response.json();

              case 6:
                result = _context2.sent;
                promises = result.list.map( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(list) {
                    var baseUri, metaId, metadataUri, _yield$_this$fetchMet, metadata;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            baseUri = list.token.thing.store.baseUri;
                            metaId = list.token.thing.metaId;
                            metadataUri = (0, _urlcat["default"])(baseUri, metaId);
                            _context.next = 5;
                            return _this.fetchMetadata(metadataUri);

                          case 5:
                            _yield$_this$fetchMet = _context.sent;
                            metadata = _yield$_this$fetchMet.data;
                            return _context.abrupt("return", _objectSpread(_objectSpread({}, list), {}, {
                              metadata: metadata
                            }));

                          case 8:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x3) {
                    return _ref.apply(this, arguments);
                  };
                }());
                _context2.next = 10;
                return Promise.all(promises);

              case 10:
                data = _context2.sent;
                return _context2.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: data
                }));

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchMarketplace(_x, _x2) {
        return _fetchMarketplace.apply(this, arguments);
      }

      return fetchMarketplace;
    }() // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "fetchAccount",
    value: function () {
      var _fetchAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(accountId) {
        var url, response, result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = (0, _urlcat["default"])("".concat(this.apiBaseUrl, "/api/rest/"), '/accounts/:accountId', {
                  accountId: accountId
                });
                _context3.next = 3;
                return fetch(url);

              case 3:
                response = _context3.sent;
                _context3.next = 6;
                return response.json();

              case 6:
                result = _context3.sent;
                return _context3.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: result
                }));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchAccount(_x4) {
        return _fetchAccount.apply(this, arguments);
      }

      return fetchAccount;
    }()
  }, {
    key: "fetchTokenApprovals",
    value: function () {
      var _fetchTokenApprovals = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(tokenKey, contractAddress) {
        var url, response, result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                url = (0, _urlcat["default"])("".concat(this.apiBaseUrl, "/api/rest/"), '/token-approvals', {
                  accountId: contractAddress,
                  tokenKey: tokenKey
                });
                _context4.next = 3;
                return fetch(url);

              case 3:
                response = _context4.sent;
                _context4.next = 6;
                return response.json();

              case 6:
                result = _context4.sent;
                return _context4.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: result
                }));

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function fetchTokenApprovals(_x5, _x6) {
        return _fetchTokenApprovals.apply(this, arguments);
      }

      return fetchTokenApprovals;
    }()
  }, {
    key: "fetchApprovals",
    value: function () {
      var _fetchApprovals = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(offset, limit) {
        var url, response, result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                url = (0, _urlcat["default"])("".concat(this.apiBaseUrl, "/api/rest/"), '/approvals/', {
                  limit: limit || this.defaultLimit,
                  offset: offset || 0
                });
                _context5.next = 3;
                return fetch(url);

              case 3:
                response = _context5.sent;
                _context5.next = 6;
                return response.json();

              case 6:
                result = _context5.sent;
                return _context5.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: result
                }));

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchApprovals(_x7, _x8) {
        return _fetchApprovals.apply(this, arguments);
      }

      return fetchApprovals;
    }()
    /**
     * Fetch thing metadata.
     * @param thingId Thing Id
     * @returns token metadata
     */

  }, {
    key: "fetchThingMetadata",
    value: function () {
      var _fetchThingMetadata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(thingId) {
        var url, response, result, thing, metadataUri, _yield$this$fetchMeta, metadata, error;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                url = (0, _urlcat["default"])("".concat(this.apiBaseUrl, "/api/rest/"), '/things/:id', {
                  id: thingId
                });
                _context6.next = 3;
                return fetch(url);

              case 3:
                response = _context6.sent;
                _context6.next = 6;
                return response.json();

              case 6:
                result = _context6.sent;

                if (!(result.thing.length === 0)) {
                  _context6.next = 9;
                  break;
                }

                return _context6.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: "".concat(thingId, " is not a valid thing.")
                }));

              case 9:
                thing = result.thing[0];
                metadataUri = (0, _urlcat["default"])(thing.store.baseUri, thing.metaId);
                _context6.next = 13;
                return this.fetchMetadata(metadataUri);

              case 13:
                _yield$this$fetchMeta = _context6.sent;
                metadata = _yield$this$fetchMeta.data;
                error = _yield$this$fetchMeta.error;

                if (!error) {
                  _context6.next = 18;
                  break;
                }

                return _context6.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: error
                }));

              case 18:
                return _context6.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: metadata
                }));

              case 19:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function fetchThingMetadata(_x9) {
        return _fetchThingMetadata.apply(this, arguments);
      }

      return fetchThingMetadata;
    }()
    /**
     * Fetch list by id.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "fetchListById",
    value: function () {
      var _fetchListById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id) {
        var url, response, result, list;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                url = (0, _urlcat["default"])("".concat(this.apiBaseUrl, "/api/rest/"), '/lists/:id', {
                  id: id
                });
                _context7.next = 3;
                return fetch(url);

              case 3:
                response = _context7.sent;
                _context7.next = 6;
                return response.json();

              case 6:
                result = _context7.sent;

                if (!(result.list.length === 0)) {
                  _context7.next = 9;
                  break;
                }

                return _context7.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: "No results for ".concat(id)
                }));

              case 9:
                list = result.list[0];
                return _context7.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: list
                }));

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function fetchListById(_x10) {
        return _fetchListById.apply(this, arguments);
      }

      return fetchListById;
    }() // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "fetchLists",
    value: function () {
      var _fetchLists = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(offset, limit) {
        var url, response, result;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                url = (0, _urlcat["default"])("".concat(this.apiBaseUrl, "/api/rest/"), '/lists/', {
                  limit: limit || this.defaultLimit,
                  offset: offset || 0
                });
                _context8.next = 3;
                return fetch(url);

              case 3:
                response = _context8.sent;
                _context8.next = 6;
                return response.json();

              case 6:
                result = _context8.sent;
                return _context8.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: result
                }));

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function fetchLists(_x11, _x12) {
        return _fetchLists.apply(this, arguments);
      }

      return fetchLists;
    }()
    /**
     * Fetch thing by Id
     * TODO: Not yet implemented
     */

  }, {
    key: "fetchThingById",
    value: function () {
      var _fetchThingById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(thingId) {
        var url, response, result;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                url = (0, _urlcat["default"])("".concat(this.apiBaseUrl, "/api/rest/"), '/things/:id', {
                  id: thingId
                });
                _context9.next = 3;
                return fetch(url);

              case 3:
                response = _context9.sent;
                _context9.next = 6;
                return response.json();

              case 6:
                result = _context9.sent;
                return _context9.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: result
                }));

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function fetchThingById(_x13) {
        return _fetchThingById.apply(this, arguments);
      }

      return fetchThingById;
    }()
    /**
     * Fetch thing.
     */

  }, {
    key: "fetchThings",
    value: function () {
      var _fetchThings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(offset, limit) {
        var url, response, result;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                url = (0, _urlcat["default"])("".concat(this.apiBaseUrl, "/api/rest/"), '/things/', {
                  limit: limit || this.defaultLimit,
                  offset: offset || 0
                });
                _context10.next = 3;
                return fetch(url);

              case 3:
                response = _context10.sent;
                _context10.next = 6;
                return response.json();

              case 6:
                result = _context10.sent;
                return _context10.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: result
                }));

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function fetchThings(_x14, _x15) {
        return _fetchThings.apply(this, arguments);
      }

      return fetchThings;
    }()
    /**
     * Fetch token
     * @param tokenId token id
     * @returns the token data
     */

  }, {
    key: "fetchTokenById",
    value: function () {
      var _fetchTokenById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(tokenId) {
        var url, response, result, token;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                url = (0, _urlcat["default"])("".concat(this.apiBaseUrl, "/api/rest/"), '/tokens/:id', {
                  id: tokenId
                });
                _context11.next = 3;
                return fetch(url);

              case 3:
                response = _context11.sent;
                _context11.next = 6;
                return response.json();

              case 6:
                result = _context11.sent;

                if (!(result.token.length === 0)) {
                  _context11.next = 9;
                  break;
                }

                return _context11.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: "".concat(tokenId, " is not a valid token")
                }));

              case 9:
                token = result.token[0];
                return _context11.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: token
                }));

              case 11:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function fetchTokenById(_x16) {
        return _fetchTokenById.apply(this, arguments);
      }

      return fetchTokenById;
    }()
  }, {
    key: "fetchTokens",
    value: function () {
      var _fetchTokens = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(offset, limit) {
        var url, response, result;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                url = (0, _urlcat["default"])("".concat(this.apiBaseUrl, "/api/rest/"), '/tokens/', {
                  limit: limit || this.defaultLimit,
                  offset: offset || 0
                });
                _context12.next = 3;
                return fetch(url);

              case 3:
                response = _context12.sent;
                _context12.next = 6;
                return response.json();

              case 6:
                result = _context12.sent;
                return _context12.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: result
                }));

              case 8:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function fetchTokens(_x17, _x18) {
        return _fetchTokens.apply(this, arguments);
      }

      return fetchTokens;
    }()
  }, {
    key: "fetchStoreById",
    value: function () {
      var _fetchStoreById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(storeId) {
        var url, response, result;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                url = (0, _urlcat["default"])("".concat(this.apiBaseUrl, "/api/rest/"), '/stores/:id/', {
                  id: storeId
                });
                _context13.next = 3;
                return fetch(url);

              case 3:
                response = _context13.sent;
                _context13.next = 6;
                return response.json();

              case 6:
                result = _context13.sent;
                return _context13.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: result
                }));

              case 8:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function fetchStoreById(_x19) {
        return _fetchStoreById.apply(this, arguments);
      }

      return fetchStoreById;
    }()
  }, {
    key: "fetchStores",
    value: function () {
      var _fetchStores = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(offset, limit) {
        var url, response, result;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                url = (0, _urlcat["default"])("".concat(this.apiBaseUrl, "/api/rest/"), '/stores/', {
                  limit: limit || this.defaultLimit,
                  offset: offset || 0
                });
                _context14.next = 3;
                return fetch(url);

              case 3:
                response = _context14.sent;
                _context14.next = 6;
                return response.json();

              case 6:
                result = _context14.sent;
                return _context14.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: result
                }));

              case 8:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function fetchStores(_x20, _x21) {
        return _fetchStores.apply(this, arguments);
      }

      return fetchStores;
    }()
  }, {
    key: "fetchCategories",
    value: function () {
      var _fetchCategories = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var url, response, result, categories;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                url = (0, _urlcat["default"])("".concat(this.apiBaseUrl, "/api/rest/"), '/categories/');
                _context15.next = 3;
                return fetch(url);

              case 3:
                response = _context15.sent;
                _context15.next = 6;
                return response.json();

              case 6:
                result = _context15.sent;
                categories = result.thing.map(function (category) {
                  return category.memo;
                });
                return _context15.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: categories
                }));

              case 9:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function fetchCategories() {
        return _fetchCategories.apply(this, arguments);
      }

      return fetchCategories;
    }()
  }, {
    key: "fetchStats",
    value: function () {
      var _fetchStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var url, response, result;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                url = (0, _urlcat["default"])("".concat(this.apiBaseUrl, "/api/rest/"), '/stats/');
                _context16.next = 3;
                return fetch(url);

              case 3:
                response = _context16.sent;
                _context16.next = 6;
                return response.json();

              case 6:
                result = _context16.sent;
                return _context16.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: result
                }));

              case 8:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function fetchStats() {
        return _fetchStats.apply(this, arguments);
      }

      return fetchStats;
    }()
    /**
     * Checks whether account owns a token or not.
     * @param tokenId token id
     * @param accountId account id
     * @returns whether an account owns a token or not.
     */

  }, {
    key: "isTokenOwner",
    value: function () {
      var _isTokenOwner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(accountId, tokenKey) {
        var _yield$this$fetchToke, token, data;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.fetchTokenById(tokenKey);

              case 2:
                _yield$this$fetchToke = _context17.sent;
                token = _yield$this$fetchToke.data;

                if (token) {
                  _context17.next = 6;
                  break;
                }

                return _context17.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: false
                }));

              case 6:
                data = (token === null || token === void 0 ? void 0 : token.ownerId) === accountId;
                return _context17.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: data
                }));

              case 8:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function isTokenOwner(_x22, _x23) {
        return _isTokenOwner.apply(this, arguments);
      }

      return isTokenOwner;
    }()
    /**
     * Fetch metadata from Arweave
     * @param id arweave content identifier
     * @returns metadata
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "fetchMetadata",
    value: function () {
      var _fetchMetadata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(url) {
        var request, data;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return fetch(url);

              case 2:
                request = _context18.sent;

                if (request.ok) {
                  _context18.next = 5;
                  break;
                }

                return _context18.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Not found'
                }));

              case 5:
                _context18.next = 7;
                return request.json();

              case 7:
                data = _context18.sent;
                return _context18.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: data
                }));

              case 9:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      function fetchMetadata(_x24) {
        return _fetchMetadata.apply(this, arguments);
      }

      return fetchMetadata;
    }()
    /**
     * Makes custom GraphQL query
     * @param query custom GraphQL query
     * @param variables object with variables passed to the query
     * @returns result of query
     */

  }, {
    key: "custom",
    value: function () {
      var _custom = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(query, variables) {
        var url, data;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                url = (0, _urlcat["default"])(this.apiBaseUrl, '/v1/graphql');
                _context19.prev = 1;
                _context19.next = 4;
                return (0, _graphqlRequest.request)(url, query, variables);

              case 4:
                data = _context19.sent;
                return _context19.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: data
                }));

              case 8:
                _context19.prev = 8;
                _context19.t0 = _context19["catch"](1);
                return _context19.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _context19.t0.message
                }));

              case 11:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[1, 8]]);
      }));

      function custom(_x25, _x26) {
        return _custom.apply(this, arguments);
      }

      return custom;
    }()
  }]);

  return API;
}();

exports.API = API;